import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  fr: {
    translation: {
      // Common
      login: "Se connecter", logout: "Déconnexion", email: "Email", password: "Mot de passe",
      loading: "Chargement…", save: "Enregistrer", cancel: "Annuler", delete: "Supprimer",
      submit: "Envoyer", confirm: "Confirmer", search: "Rechercher", back: "Retour",
      success: "Succès", failed: "Échec", pending: "En attente", active: "Actif", inactive: "Inactif",
      suspended: "Suspendu",
      // Auth
      login_title: "Espace Technicien",
      login_subtitle: "Connectez-vous à votre serveur",
      login_no_account: "Pas encore de compte ?",
      login_create: "Créer un compte",
      register_title: "Créer un compte",
      register_subtitle: "Ouvrez votre espace technicien LHSunlocker",
      register_name: "Nom complet",
      register_workshop: "Atelier / Boutique (optionnel)",
      register_password_hint: "Mot de passe (6+ caractères)",
      register_submit: "Créer mon compte",
      register_have_account: "Déjà un compte ?",
      // Sidebar
      nav_dashboard: "Tableau de bord", nav_android: "Android", nav_mediatek: "MediaTek",
      nav_qualcomm: "Qualcomm", nav_unisoc: "Unisoc", nav_infinity: "Infinity",
      nav_ios: "iOS", nav_general: "Général", nav_firmware: "Firmware",
      nav_hello_bypass: "Hello Bypass",
      nav_store: "Logiciels tiers",
      nav_my_3p_licenses: "Mes licences tierces",
      nav_licences: "Licences", nav_payments: "Paiements", nav_history: "Historique",
      nav_settings: "Paramètres", nav_admin: "Panneau Admin",
      // Topbar
      server_connected: "SERVEUR LHS · CONNECTÉ",
      // Download
      download_client: "Télécharger le client Windows",
      download_available: "Version {{v}} disponible pour Windows 7/8/10/11",
      // Dashboard
      dash_welcome: "Bienvenue",
      dash_hi: "Salut,",
      dash_desc: "Sélectionnez une plateforme, connectez l'appareil et lancez l'opération autorisée.",
      dash_stats_total: "Opérations totales", dash_stats_success: "Succès",
      dash_stats_failed: "Échecs", dash_stats_rate: "Taux de succès",
      // Payments
      pay_title: "Achat & Renouvellement Licence",
      pay_subtitle: "Airtel Money · Orange Money · Binance Pay",
      pay_tab_buy: "Acheter", pay_tab_mine: "Mes paiements", pay_tab_admin: "Admin",
      pay_choose_plan: "1. Formule",
      pay_choose_method: "2. Moyen de paiement",
      pay_options: "3. Options & confirmation",
      pay_coupon_placeholder: "Code promo (optionnel)",
      pay_validate_coupon: "Valider",
      pay_coupon_applied: "-{{p}}% appliqué",
      pay_whatsapp_placeholder: "Numéro WhatsApp (+243...) pour notification",
      pay_generate: "Générer les instructions",
      pay_reference: "Référence",
      pay_txid: "Transaction ID (obligatoire)",
      pay_phone: "Téléphone payeur (optionnel)",
      pay_note: "Note (optionnel)",
      pay_send_proof: "Envoyer la preuve",
      pay_waiting_review: "En attente de validation par l'administrateur.",
      pay_approved: "Approuvé — Licence :",
      // Firmware
      fw_title: "Fichiers DA · Auth · Loader",
      fw_subtitle_admin: "Ajoutez et gérez les fichiers.",
      fw_subtitle_user: "Téléchargez les fichiers nécessaires à vos opérations.",
      fw_upload: "Ajouter un fichier",
      fw_download: "Télécharger",
      fw_license_required: "Licence active requise",
      fw_all_platforms: "Toutes plateformes",
      fw_all_brands: "Toutes marques",
      fw_all_kinds: "Tous types",
      fw_downloads: "téléchargements",
      // Settings
      settings_title: "Paramètres",
      settings_profile: "Profil technicien",
      settings_password: "Changer le mot de passe",
      settings_current_pw: "Mot de passe actuel",
      settings_new_pw: "Nouveau mot de passe (6+ car.)",
      settings_confirm_pw: "Confirmer le nouveau mot de passe",
      settings_change: "Changer",
      settings_language: "Langue",
      // License gating
      license_required_title: "Licence requise",
      license_required_desc: "Cette fonctionnalité nécessite une licence active. Effectuez un paiement pour débloquer l'accès complet.",
      license_go_pay: "Acheter une licence",
      license_status: "Statut licence",
      // Admin
      admin_title: "Administration LHSunlocker",
      admin_users: "Utilisateurs", admin_active_licenses: "Licences actives",
      admin_gen_licenses: "Générateur de licences",
      admin_coupons: "Codes promo",
      admin_coupon_code: "Code (ex: LHSPROMO)",
      admin_coupon_pct: "% off",
      admin_coupon_uses: "Nb max",
      admin_coupon_create: "Créer",
    },
  },
  en: {
    translation: {
      login: "Sign in", logout: "Logout", email: "Email", password: "Password",
      loading: "Loading…", save: "Save", cancel: "Cancel", delete: "Delete",
      submit: "Send", confirm: "Confirm", search: "Search", back: "Back",
      success: "Success", failed: "Failed", pending: "Pending", active: "Active", inactive: "Inactive",
      suspended: "Suspended",
      login_title: "Technician Portal",
      login_subtitle: "Sign in to your server",
      login_no_account: "No account yet?",
      login_create: "Create an account",
      register_title: "Create account",
      register_subtitle: "Open your LHSunlocker technician workspace",
      register_name: "Full name",
      register_workshop: "Workshop / Store (optional)",
      register_password_hint: "Password (6+ characters)",
      register_submit: "Create my account",
      register_have_account: "Already have an account?",
      nav_dashboard: "Dashboard", nav_android: "Android", nav_mediatek: "MediaTek",
      nav_qualcomm: "Qualcomm", nav_unisoc: "Unisoc", nav_infinity: "Infinity",
      nav_ios: "iOS", nav_general: "General", nav_firmware: "Firmware",
      nav_hello_bypass: "Hello Bypass",
      nav_store: "Third-party tools",
      nav_my_3p_licenses: "My 3rd-party licenses",
      nav_licences: "Licenses", nav_payments: "Payments", nav_history: "History",
      nav_settings: "Settings", nav_admin: "Admin Panel",
      server_connected: "LHS SERVER · CONNECTED",
      download_client: "Download Windows Client",
      download_available: "Version {{v}} available for Windows 7/8/10/11",
      dash_welcome: "Welcome", dash_hi: "Hi,",
      dash_desc: "Select a platform, connect the device and run the authorized operation.",
      dash_stats_total: "Total ops", dash_stats_success: "Success",
      dash_stats_failed: "Failed", dash_stats_rate: "Success rate",
      pay_title: "Buy & Renew License",
      pay_subtitle: "Airtel Money · Orange Money · Binance Pay",
      pay_tab_buy: "Buy", pay_tab_mine: "My payments", pay_tab_admin: "Admin",
      pay_choose_plan: "1. Plan",
      pay_choose_method: "2. Payment method",
      pay_options: "3. Options & confirmation",
      pay_coupon_placeholder: "Promo code (optional)",
      pay_validate_coupon: "Apply",
      pay_coupon_applied: "-{{p}}% applied",
      pay_whatsapp_placeholder: "WhatsApp number (+243...) for notifications",
      pay_generate: "Generate instructions",
      pay_reference: "Reference",
      pay_txid: "Transaction ID (required)",
      pay_phone: "Payer phone (optional)",
      pay_note: "Note (optional)",
      pay_send_proof: "Send proof",
      pay_waiting_review: "Waiting for admin validation.",
      pay_approved: "Approved — License:",
      fw_title: "DA · Auth · Loader files",
      fw_subtitle_admin: "Add and manage files.",
      fw_subtitle_user: "Download files needed for your operations.",
      fw_upload: "Add a file",
      fw_download: "Download",
      fw_license_required: "Active license required",
      fw_all_platforms: "All platforms",
      fw_all_brands: "All brands",
      fw_all_kinds: "All types",
      fw_downloads: "downloads",
      settings_title: "Settings",
      settings_profile: "Technician profile",
      settings_password: "Change password",
      settings_current_pw: "Current password",
      settings_new_pw: "New password (6+ chars)",
      settings_confirm_pw: "Confirm new password",
      settings_change: "Change",
      settings_language: "Language",
      license_required_title: "License required",
      license_required_desc: "This feature requires an active license. Complete a payment to unlock full access.",
      license_go_pay: "Buy a license",
      license_status: "License status",
      admin_title: "LHSunlocker Administration",
      admin_users: "Users", admin_active_licenses: "Active licenses",
      admin_gen_licenses: "License generator",
      admin_coupons: "Promo codes",
      admin_coupon_code: "Code (e.g. LHSPROMO)",
      admin_coupon_pct: "% off",
      admin_coupon_uses: "Max uses",
      admin_coupon_create: "Create",
    },
  },
  ar: {
    translation: {
      login: "تسجيل الدخول", logout: "تسجيل الخروج", email: "البريد الإلكتروني", password: "كلمة المرور",
      loading: "جار التحميل…", save: "حفظ", cancel: "إلغاء", delete: "حذف",
      submit: "إرسال", confirm: "تأكيد", search: "بحث", back: "رجوع",
      success: "نجاح", failed: "فشل", pending: "قيد الانتظار", active: "نشط", inactive: "غير نشط",
      suspended: "معلق",
      login_title: "بوابة الفني",
      login_subtitle: "سجل الدخول إلى الخادم الخاص بك",
      login_no_account: "ليس لديك حساب بعد؟",
      login_create: "إنشاء حساب",
      register_title: "إنشاء حساب",
      register_subtitle: "افتح مساحة الفني الخاصة بك على LHSunlocker",
      register_name: "الاسم الكامل",
      register_workshop: "الورشة / المتجر (اختياري)",
      register_password_hint: "كلمة المرور (6+ أحرف)",
      register_submit: "إنشاء حسابي",
      register_have_account: "لديك حساب بالفعل؟",
      nav_dashboard: "لوحة التحكم", nav_android: "أندرويد", nav_mediatek: "MediaTek",
      nav_qualcomm: "Qualcomm", nav_unisoc: "Unisoc", nav_infinity: "Infinity",
      nav_ios: "iOS", nav_general: "عام", nav_firmware: "الفيرموير",
      nav_hello_bypass: "تجاوز Hello",
      nav_store: "برامج أخرى",
      nav_my_3p_licenses: "تراخيصي الخارجية",
      nav_licences: "التراخيص", nav_payments: "المدفوعات", nav_history: "السجل",
      nav_settings: "الإعدادات", nav_admin: "لوحة المشرف",
      server_connected: "خادم LHS · متصل",
      download_client: "تنزيل برنامج ويندوز",
      download_available: "الإصدار {{v}} متوفر لنظام Windows 7/8/10/11",
      dash_welcome: "مرحباً", dash_hi: "مرحبا،",
      dash_desc: "اختر منصة، وقم بتوصيل الجهاز وابدأ العملية المصرح بها.",
      dash_stats_total: "إجمالي العمليات", dash_stats_success: "ناجحة",
      dash_stats_failed: "فاشلة", dash_stats_rate: "معدل النجاح",
      pay_title: "شراء وتجديد الترخيص",
      pay_subtitle: "Airtel Money · Orange Money · Binance Pay",
      pay_tab_buy: "شراء", pay_tab_mine: "مدفوعاتي", pay_tab_admin: "المشرف",
      pay_choose_plan: "1. الباقة",
      pay_choose_method: "2. طريقة الدفع",
      pay_options: "3. الخيارات والتأكيد",
      pay_coupon_placeholder: "كود الخصم (اختياري)",
      pay_validate_coupon: "تطبيق",
      pay_coupon_applied: "-{{p}}% تم التطبيق",
      pay_whatsapp_placeholder: "رقم واتساب (+243...) للإشعارات",
      pay_generate: "إنشاء التعليمات",
      pay_reference: "المرجع",
      pay_txid: "معرف المعاملة (مطلوب)",
      pay_phone: "هاتف الدافع (اختياري)",
      pay_note: "ملاحظة (اختياري)",
      pay_send_proof: "إرسال الإثبات",
      pay_waiting_review: "في انتظار موافقة المشرف.",
      pay_approved: "تمت الموافقة — الترخيص:",
      fw_title: "ملفات DA · Auth · Loader",
      fw_subtitle_admin: "أضف وأدر الملفات.",
      fw_subtitle_user: "قم بتنزيل الملفات اللازمة لعملياتك.",
      fw_upload: "إضافة ملف",
      fw_download: "تنزيل",
      fw_license_required: "ترخيص نشط مطلوب",
      fw_all_platforms: "جميع المنصات",
      fw_all_brands: "جميع الماركات",
      fw_all_kinds: "جميع الأنواع",
      fw_downloads: "تنزيلات",
      settings_title: "الإعدادات",
      settings_profile: "الملف الشخصي للفني",
      settings_password: "تغيير كلمة المرور",
      settings_current_pw: "كلمة المرور الحالية",
      settings_new_pw: "كلمة المرور الجديدة (6+ أحرف)",
      settings_confirm_pw: "تأكيد كلمة المرور الجديدة",
      settings_change: "تغيير",
      settings_language: "اللغة",
      license_required_title: "الترخيص مطلوب",
      license_required_desc: "تتطلب هذه الميزة ترخيصاً نشطاً. أكمل الدفع لفتح الوصول الكامل.",
      license_go_pay: "شراء ترخيص",
      license_status: "حالة الترخيص",
      admin_title: "إدارة LHSunlocker",
      admin_users: "المستخدمون", admin_active_licenses: "التراخيص النشطة",
      admin_gen_licenses: "منشئ التراخيص",
      admin_coupons: "أكواد الخصم",
      admin_coupon_code: "الكود (مثال LHSPROMO)",
      admin_coupon_pct: "% خصم",
      admin_coupon_uses: "الحد الأقصى",
      admin_coupon_create: "إنشاء",
    },
  },
};

const saved = typeof window !== "undefined" ? localStorage.getItem("lhs_lang") : null;

i18n.use(initReactI18next).init({
  resources,
  lng: saved || "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export function setLanguage(lng) {
  i18n.changeLanguage(lng);
  localStorage.setItem("lhs_lang", lng);
  document.documentElement.setAttribute("lang", lng);
  document.documentElement.setAttribute("dir", lng === "ar" ? "rtl" : "ltr");
}

// initialize dir on load
if (typeof document !== "undefined") {
  document.documentElement.setAttribute("lang", i18n.language);
  document.documentElement.setAttribute("dir", i18n.language === "ar" ? "rtl" : "ltr");
}

export default i18n;
